import { render, staticRenderFns } from "./btnTools.vue?vue&type=template&id=bae3e202&scoped=true"
import script from "./btnTools.vue?vue&type=script&lang=js"
export * from "./btnTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae3e202",
  null
  
)

/* custom blocks */
import block0 from "./btnTools.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports